import React from "react";
// import myImg from "../../Assets/avatar.svg";
import myImg from "../../Assets/shamim2.png";


function Home2() {
  return (
    <>
    <div className="container home-about-section pt-5 pb-5" id="about">
        <div className="row aboutRow">
            <div className="col-md-5 col-sm-12" id="overlayTop">
              <div className="overlay">
               <div className="img-bg">
                <div className="borderr">
                 <div className="Box">
                   <img data-aos="zoom-in" src={myImg} className="myAvaterimg" alt="avatar" />
                 </div>
                 </div>
                </div>
               </div>
            </div> 
            <div className="col-md-7 col-sm-12 p-3">
             <p className="home-about-description" style={{fontSize: "17px"}}>
              Well, I'm a programmer and Please don't tell me that <br />
                I've   to fix your Computer! 😂😂
              <br />
              <br />Basically, I am proficient in 
              <b className="purple"> CSS, React, Javascript, Node js and Express </b>
               <br/> My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  Deep Learning and Natural Launguage Processing.
                </b>
              </i>
             </p>
            </div> 
         </div>
    </div>
    </>
  );
}
export default Home2;
